var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { SdsButtonBase } from '../_sds-button-base.lit';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `SdsButtonUpload` is a custom button component for file uploads.
 *
 * Attributes:
 * - `icon`: If defined, the icon will be displayed on the button.
 *
 * Events:
 * - `sds.file.selected`: Dispatched when a file is selected, with the `fileName` in the event's `detail`.
 *
 * @tag sds-button-upload
 */
let SdsButtonUpload = (() => {
    var _SdsButtonUpload_icon_accessor_storage, _SdsButtonUpload_multiple_accessor_storage, _SdsButtonUpload_accept_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-button-upload')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsButtonBase;
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _multiple_decorators;
    let _multiple_initializers = [];
    let _multiple_extraInitializers = [];
    let _accept_decorators;
    let _accept_initializers = [];
    let _accept_extraInitializers = [];
    var SdsButtonUpload = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsButtonUpload_icon_accessor_storage.set(this, __runInitializers(this, _icon_initializers, void 0));
            _SdsButtonUpload_multiple_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _multiple_initializers, false)));
            _SdsButtonUpload_accept_accessor_storage.set(this, (__runInitializers(this, _multiple_extraInitializers), __runInitializers(this, _accept_initializers, void 0)));
            this._triggerFileInput = (__runInitializers(this, _accept_extraInitializers), () => {
                var _a;
                const input = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('input[type="file"]');
                input === null || input === void 0 ? void 0 : input.click();
            });
            this._handleFileChange = (event) => {
                const fileInput = event.target;
                const files = fileInput.files ? Array.from(fileInput.files) : [];
                if (files.length > 0) {
                    this.dispatchEvent(new CustomEvent(SdsButtonUpload.SELECTED_EVENT, {
                        detail: { files: files },
                        bubbles: true,
                        composed: true,
                    }));
                }
                fileInput.value = '';
            };
        }
        /**
         * Button icon
         * @attr
         */
        get icon() { return __classPrivateFieldGet(this, _SdsButtonUpload_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsButtonUpload_icon_accessor_storage, value, "f"); }
        get multiple() { return __classPrivateFieldGet(this, _SdsButtonUpload_multiple_accessor_storage, "f"); }
        set multiple(value) { __classPrivateFieldSet(this, _SdsButtonUpload_multiple_accessor_storage, value, "f"); }
        get accept() { return __classPrivateFieldGet(this, _SdsButtonUpload_accept_accessor_storage, "f"); }
        set accept(value) { __classPrivateFieldSet(this, _SdsButtonUpload_accept_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-button
                label="${this.label}"
                size="${this.size}"
                type="${this.type}"
                .icon="${this.icon}"
                ?error="${this.error}"
                ?selected="${this.selected}"
                ?loading="${this.loading}"
                ?disabled="${this.disabled}"
                ?with-shadow="${this.withShadow}"
                @click="${this._triggerFileInput}"
            ></sds-button>
            <input
                type="file"
                style="display:none;"
                @change="${this._handleFileChange}"
                ?multiple="${this.multiple}"
                accept="${this.accept}"
            />
        `;
        }
    };
    _SdsButtonUpload_icon_accessor_storage = new WeakMap();
    _SdsButtonUpload_multiple_accessor_storage = new WeakMap();
    _SdsButtonUpload_accept_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsButtonUpload");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _icon_decorators = [property({ type: String })];
        _multiple_decorators = [property({ type: Boolean })];
        _accept_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _multiple_decorators, { kind: "accessor", name: "multiple", static: false, private: false, access: { has: obj => "multiple" in obj, get: obj => obj.multiple, set: (obj, value) => { obj.multiple = value; } }, metadata: _metadata }, _multiple_initializers, _multiple_extraInitializers);
        __esDecorate(_classThis, null, _accept_decorators, { kind: "accessor", name: "accept", static: false, private: false, access: { has: obj => "accept" in obj, get: obj => obj.accept, set: (obj, value) => { obj.accept = value; } }, metadata: _metadata }, _accept_initializers, _accept_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsButtonUpload = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.SELECTED_EVENT = 'sds.files.selected';
    _classThis.shadowRootOptions = Object.assign(Object.assign({}, LitElement.shadowRootOptions), { delegatesFocus: true });
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsButtonUpload = _classThis;
})();
export { SdsButtonUpload };
